import React from 'react';
import styled from 'styled-components';
import { IconWrapper, SvgIcon } from '../../Icon';
import KubitTooltip from '../../KubitTooltip';
import TableEditableCellPlaceholder from '../../Table/TableEditableCellPlaceholder';

interface IProps {
  onClick: () => void;
  hidden: boolean;
  showPlaceholder?: boolean;
}

const IconContainer = styled(IconWrapper)`
  margin-top: 2px;
`;

const ApplyTagsAction = ({ onClick, hidden, showPlaceholder }: IProps) => {
  if (showPlaceholder) {
    return (
      <TableEditableCellPlaceholder
        placeholder={'Apply Tags...'}
        iconName="plus-square-fill"
        onClick={onClick}
        hidden={hidden}
      />
    );
  }

  return (
    <KubitTooltip
      content="Apply Tags"
      placement="bottom"
      disabled={showPlaceholder}
      noOpenDelay={true}
    >
      <IconContainer
        onClick={onClick}
        size={16}
        style={{ opacity: hidden ? 0 : 1 }}
      >
        <SvgIcon
          name="plus-square-fill"
          width={16}
          height={16}
          customFill="currentColor"
        />
      </IconContainer>
    </KubitTooltip>
  );
};

export default ApplyTagsAction;
